import { Cell, Text } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

const AccountLink = _ref => {
  let {
    title,
    url,
    suffix,
    onClick,
    testId
  } = _ref;
  return /*#__PURE__*/_jsx(Cell, {
    testId: testId,
    type: Cell.Type.Navigating,
    body: /*#__PURE__*/_jsx(Text, {
      text: title
    }),
    url: url,
    onClick: onClick,
    suffix: suffix
  });
};

export default AccountLink;